var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberTwoSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "two-number-round") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fd7e00",
    className: "cls-1",
    d: "M61.44,0A61.46,61.46,0,1,1,18,18,61.21,61.21,0,0,1,61.44,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.35,84.59V75.67l17-14.1a38.24,38.24,0,0,0,2.91-2.64,10.46,10.46,0,0,0,1.87-2.55,6.46,6.46,0,0,0,.66-2.92,5.73,5.73,0,0,0-.75-3A4.9,4.9,0,0,0,64,48.52a7,7,0,0,0-6.05,0,4.74,4.74,0,0,0-2,2,6.76,6.76,0,0,0-.71,3.25H43.46a15.46,15.46,0,0,1,2.16-8.3,14.24,14.24,0,0,1,6.11-5.35A21.23,21.23,0,0,1,61,38.29,23.52,23.52,0,0,1,70.51,40,14.15,14.15,0,0,1,76.73,45a12.69,12.69,0,0,1,2.19,7.42,13.32,13.32,0,0,1-1.08,5.23,22,22,0,0,1-3.93,5.75,81.14,81.14,0,0,1-8,7.49l-4.28,3.57v.27H79.42v9.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTwoSolid);
export default __webpack_public_path__ + "static/media/number-two-solid.43cda64dba1af1614ab0f2bf0f80d7ad.svg";
export { ForwardRef as ReactComponent };